import { render } from "./KontaktPthPeje.vue?vue&type=template&id=0cebdafa"
import script from "./KontaktPthPeje.vue?vue&type=script&lang=js"
export * from "./KontaktPthPeje.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__